import React from 'react';
import AppLayout from '../../components/AppLayout';
import usePageTitle from '../../utils/usePageTitle';

function Dashboard() {
    usePageTitle('Dashboard');

    return (
        <AppLayout>
            <div className="space-y-6">
                {/* Header */}
                <div>
                    <h1 className="text-2xl font-bold text-gray-900">Dashboard</h1>
                    <p className="text-sm text-gray-500 mt-1">Visão geral do sistema</p>
                </div>

                {/* Welcome Card */}
                <div className="bg-white p-6 rounded-lg border border-gray-200">
                    <div className="text-center">
                        <h2 className="text-xl font-semibold text-gray-900 mb-2">Bem-vindo ao sistema</h2>
                        <p className="text-gray-600">
                            Use o menu lateral para navegar pelas funcionalidades disponíveis.
                        </p>
                    </div>
                </div>
            </div>
        </AppLayout>
    );
}

export default Dashboard;
